import { render } from "./InstallWizardUserCreation.vue?vue&type=template&id=6a1021fa"
import script from "./InstallWizardUserCreation.vue?vue&type=script&lang=js"
export * from "./InstallWizardUserCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__